import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "Desde que comecei a treinar no EnergyGym, minha energia e disposição aumentaram muito. O ambiente motivador e os treinos intensos me ajudaram a alcançar resultados incríveis!",
    name: 'LUIS FERNANDO',
    status : 'EXECUTIVO DE VENDAS'
  },
  {
    image: image2,
    review: 'Treinar no EnergyGym foi uma das melhores decisões que tomei. A variedade de aulas e o ambiente animado me ajudaram a conquistar meus objetivos mais rápido do que imaginei!',
    name: 'ANA CLÁUDIA SILVA',
    status: 'DESIGNER GRÁFICA'
  },
  {
    image : image3,
    review:'Com o apoio do EnergyGym, consegui superar meus limites e melhorar minha saúde de maneira incrível. Cada treino me desafia e me motiva a ir mais longe!',
    name: 'CARLOS ALMEIDA',
    status: "ARQUITETO"
  }
];
